module.exports = __webpack_public_path__ + "static/images/attended.759adaa4aba251eb9f696d8e6b0e44bc.svg";